import { CONFIG_FETCH_FAILED,
         CONFIG_FETCH_SUCCESS,
         DECREMENT_SSO_REFRESH_FREQUENCY } from '../mutation-types'
import { REFRESH_SSO_TOKEN } from '../action-types'
import axios from 'axios'
import store from '../../store'

const state = {
  baseUrl: 'localhost',
  port: 8080,
  lighten4: 0.8,
  failed: false,
  error: {},
  daysForStudentAttendance: 28,
  ssoRefreshTimeout: 0,
  ssoRefreshAttempts: 0
}

const mutations = {
  [CONFIG_FETCH_SUCCESS] (state, config) {
    Object.assign(state, config)
  },
  [CONFIG_FETCH_FAILED] (state, error) {
    state.failed = true
    state.error = error
  },
  [DECREMENT_SSO_REFRESH_FREQUENCY] (state) {
    state.ssoRefreshAttempts--
  }
}

const actions = {
  [REFRESH_SSO_TOKEN] (context) {
    axios({
      url: `${context.rootState.config.baseUrl}:${context.rootState.config.port}/core/auth/refresh`,
      method: 'get',
      headers: {
        'Authorization': context.rootState.profile.loginToken
      }
    })
  }
}

const getters = {
  GET_STUDENT_TRUNCATION_SIZE (state) {
    return store.state.config.studentNameTruncationSize
  },
  GET_STUDENT_TRUNCATION_TYPE (state) {
    return store.state.config.studentNameTruncationType
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js